<template>
    <div>
        <vue2-editor
            :value="value"
            v-validate="'required'"
            :placeholder="placeholder"
            name="content"
            :data-vv-as="placeholder"
            @input="onChange"
            :editorOptions="editorOptions"
        />
        <div v-show="errors.has('content')" class="validation-message text-danger">
            Nội dung là trường bắt buộc
        </div>
    </div>
</template>
<script>
const editorOptions = {
    modules: {
        toolbar: {
            container: [
                [{ header: [false, 1, 2, 3, 4, 5, 6] }],
                ['bold', 'italic', 'underline'],
                [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
                ['blockquote'],
                [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
                [{ script: 'sub' }, { script: 'super' }],
                [{ indent: '-1' }, { indent: '+1' }],
                [{ color: [] }, { background: [] }],
                ['link']
            ]
        }
    }
};

export default {
    model: {
        prop: 'value',
        event: 'change'
    },
    props: ['placeholder', 'value'],
    computed: { editorOptions: () => editorOptions },
    methods: {
        onChange(value) {
            this.$emit('change', value);
        }
    }
};
</script>
<style lang="scss">
.quillWrapper .ql-toolbar {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #fff;
}
</style>
